"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PlaceStyles_1 = require("../style/PlaceStyles");
var StyleFunctions_1 = require("../style/StyleFunctions");
var VizPortalStyles_1 = require("../style/VizPortalStyles");
function noopFallback() {
    return '';
}
function tableauUserName(user, fallback) {
    if (!user) {
        return fallback ? fallback() : noopFallback();
    }
    return !!user.name ? user.name : user.username;
}
exports.tableauUserName = tableauUserName;
function tableauUserUrl(urls, user) {
    if (!user || !isUserActive(user) || !urls) {
        return undefined;
    }
    return urls.userUrl(user.username, user.domain);
}
exports.tableauUserUrl = tableauUserUrl;
function tableauUserPath(urls, user) {
    if (!user || !isUserActive(user) || !urls) {
        return undefined;
    }
    return urls.userPath(user.username, user.domain);
}
exports.tableauUserPath = tableauUserPath;
/**
 * An user who is no longer active has been deleted from the server.
 * This user's name is still stored in some places though, so we
 * should render it as plain text, not a hyperlink.
 */
function isUserActive(user) {
    return !!user.domain && !!user.username;
}
exports.isUserActive = isUserActive;
var linkClasses = StyleFunctions_1.classes(VizPortalStyles_1.placeHeaderMetadataLinkClass, PlaceStyles_1.placeHeaderMetadataValueClass);
function TableauUser(props) {
    var name = tableauUserName(props.tableauUser, props.fallbackUsernameText);
    var url = tableauUserUrl(props.siteUrls, props.tableauUser);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: PlaceStyles_1.placeHeaderMetadataLabelClass }, props.labelText()),
        url
            ? React.createElement("a", { href: url, target: '_blank', className: linkClasses, title: name }, name)
            : React.createElement("span", null, name)));
}
exports.TableauUser = TableauUser;
//# sourceMappingURL=TableauUser.js.map